import Fetch from '../../apiConfig/apiConfig';
import queryString from 'query-string';
import { AxiosPromise } from 'axios';
import { IAmendOrderResponse } from './IAmendOrderResponse';
import { IAmendOrderParams } from './IAmendOrderParams';

export const amendOrder = (params: IAmendOrderParams) : AxiosPromise<IAmendOrderResponse> => {
  return Fetch().then(axios => axios.post('orders/amend', params));
};
